export const BLACK_DEAL_TAGS = [
  // Germany Tags
  'burobedarf',
  'lebensmittel',
  'black-friday-angebote',
  'elektrogeraete',
  'ausstattung-fur-gastronomie-and-haushalt',

  // Netherlands Tags
  'black-friday',

  // Italy Tags
  'offerte-black-friday',

  // Portugal Tags
  'ofertas-da-black-friday',

  // Spain Tags
  'las-mejores-ofertas-black-en-calefaccion',
  'las-mejores-ofertas-black-en-menaje',
  'las-mejores-ofertas-black-en-electrodomesticos',
  'las-mejores-ofertas-black-en-equipamiento-profesional',
]
